import { getAxiosInstance } from '../blocks/axios/axiosFactory';

const url = "/clientSubsidy";

export default class ClientSubsidyService {
    static get() {
        return getAxiosInstance().get(`${url}/get`);
    }
}
